import {CsatCreateSurveyEndpointResponseSuccess} from '../../../generated/types';

/**
 * Rating selected by the user
 *
 * 1 = TERRIBLE
 * 2 = BAD
 * 3 = OKAY
 * 4 = GOOD
 * 5 = GREAT
 */
export type CSATRatingValue = '1' | '2' | '3' | '4' | '5';

export type CreateCSATSurveyRequest = {
  conversationId: string;
};

export async function createCSATSurvey(
  supportFetch: typeof fetch,
  {conversationId}: CreateCSATSurveyRequest,
): Promise<CsatCreateSurveyEndpointResponseSuccess> {
  const response = await supportFetch('/api/csat', {
    method: 'POST',
    body: JSON.stringify({conversationId}),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('failed to create csat survey');
  }

  return response.json();
}

export type SubmitCSATRatingRequest = {
  csatSurveyToken: string;
  rating: CSATRatingValue;
  comment: string;
};

export async function submitCSATRating(
  supportFetch: typeof fetch,
  {csatSurveyToken, rating, comment}: SubmitCSATRatingRequest,
): Promise<void> {
  const response = await supportFetch(`/api/csat/${csatSurveyToken}/rating`, {
    method: 'POST',
    body: JSON.stringify({rating, comment}),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('failed to submit rating');
  }
}
